import { Controller } from "@hotwired/stimulus";

// Handles file input with live preview of selected images.
// Automatically updates label and shows previews as links that open in new tabs.
export default class extends Controller {
  static targets = ["input", "label", "previewTemplate", "previewContainer"];

  connect() {
    this.inputTarget.addEventListener("change", this.handleInputChange.bind(this));
  }

  handleInputChange() {
    this.updateLabel();
    this.clearPreviews();
    this.showPreviews();
  }

  updateLabel() {
    if (!this.hasLabelTarget) return;

    const filenames = [...this.inputTarget.files].map(file => file.name).join(", ");
    this.labelTarget.textContent = filenames;
  }

  clearPreviews() {
    this.previewContainerTarget.innerHTML = "";
  }

  showPreviews() {
    [...this.inputTarget.files].forEach(file => this.showPreview(file));
  }

  showPreview(file) {
    if (!file.type.startsWith("image/")) return;

    const blobUrl = URL.createObjectURL(file);
    const preview = this.cloneTemplate();
    const img = preview.querySelector("img");
    const link = preview.querySelector("a");

    if (img && link) {
      img.src = blobUrl;
      link.href = blobUrl;
      link.target = "_blank";
    }

    this.previewContainerTarget.appendChild(preview);
  }

  cloneTemplate() {
    return this.previewTemplateTarget.content.cloneNode(true);
  }
}
